import { render, staticRenderFns } from "./AddNewProduct.vue?vue&type=template&id=b710d85e&scoped=true&"
import script from "./AddNewProduct.vue?vue&type=script&lang=js&"
export * from "./AddNewProduct.vue?vue&type=script&lang=js&"
import style0 from "./AddNewProduct.vue?vue&type=style&index=0&id=b710d85e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b710d85e",
  null
  
)

export default component.exports